<template>
  <div class="ego-title" :class="[theme,special]">
    <h1 class="h1-title" v-if="!!title" v-html="title"></h1>
    <h2 class="h2-subtitle" v-if="!!subtitle" v-html="subtitle"></h2>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'black'
    },
    special: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

.ego-title
  text-align: center
  .h1-title
    color: #353535
    font-weight: 400
    font-size: 48px
    line-height: 1
    margin-bottom: 14px
    +mobile
      margin-bottom: 10px
      font-size: 24px
      font-weight: bold
  .h2-subtitle
    color: #6e6e6e
    font-size: 18px
    +mobile
      font-size: 14px
  &.white
    .h1-title
      color: #fff
    .h2-subtitle
      color: #fff
  &.special
    +mobile
      .h1-title
        margin-bottom: 4px
</style>
